import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${primary.bluish7}`,
    paddingBottom: spacing(8),
  },
  icon: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    marginRight: spacing(3),
    flexShrink: 0,
  },
  eventIcon: {
    minWidth: 'fit-content',
    color: primary.bluish1,
    '& path': {
      fill: primary.bluish1,
    },
  },
  requalifyIcon: {
    '& path': {
      fill: primary.green1,
    },
  },
  disqualifyIcon: {
    '& path': {
      fill: primary.red1,
    },
  },
  eventText: {
    marginTop: spacing(0.5),
    minWidth: 0,
  },
  authorEvent: {
    borderBottom: `1px solid ${primary.bluish7}`,
    paddingBottom: spacing(8),
  },
  eventHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  eventInfo: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
  },
  candidate: {
    marginTop: spacing(4),
  },
  authorAvatar: {
    margin: 0,
    backgroundColor: primary.white,
    padding: 0,
    alignItems: 'center',
    minWidth: 0,
    maxWidth: '100%',
  },
  eventDetails: {
    marginTop: spacing(4),
    marginLeft: spacing(9),
    minWidth: 0,
  },
  dateLabel: {
    marginLeft: 'auto',
    marginRight: spacing(8),
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
